import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useMutation } from 'react-query'

export type CommitApplyEditsParams =
  | { designKey: string; requestId: number }
  | { designKey: string; useOriginal: true }

const commitApplyEdits = async (params: CommitApplyEditsParams & { workspaceId: number }) => {
  const { workspaceId, designKey } = params
  const body =
    'useOriginal' in params && params.useOriginal
      ? { use_original: true }
      : { request_id: (params as { requestId: number }).requestId }

  const res = await sendToApi(`/w/${workspaceId}/designs/${designKey}/commit_apply_edits`, {
    method: 'POST',
    body,
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(typeof res.data === 'string' ? res.data : 'Failed to apply selected edit version')
  }

  return res.data
}

export const useCommitApplyEdits = () => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<unknown, Error, CommitApplyEditsParams>((params) =>
    commitApplyEdits({ workspaceId, ...params }),
  )
}
